import React, { useEffect, useState } from "react";
import { IP } from "../../../../internalServer";
import { iconData } from "../../../../iconData";
import { Player } from "video-react";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
import ZoomableImage from "../../../../HwManagement/HomeWork/Pending/QuestionTypes/ZoomableImage";

export default function CheckBoxType({ questionNo, response, type, question, setQuestionsAnswer }) {
  const checkboxes = true;
  const [isClicked, setIsClicked] = useState(false);
  const [responseData, setRresponseData] = useState(response)
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };

  const handleCheckboxChange = (e) => {

    setQuestionsAnswer((prev) => {
      let updatedData = prev.map((item) => {
        if (item.id === response?.id) {
          let explanation = '';
          item.question.options.map((option) => {
            if (option.key == e.target.value) {
              explanation = option.value
            }
          })
          return {
            ...item,
            answer: {
              ...item.answer,
              key: e.target.value,
              explanation: explanation
            },
          };
        }
        return item;
      });
      return updatedData;
    });

    setRresponseData((prev) => ({
      ...prev,
      answer: {
        ...prev.answer,
        key: e.target.value
      }
    }))
  };

  useEffect(() => {
    console.log("questionNo from on review : ", questionNo)
    console.log("response from on review : ", response)
    console.log("responseData from on review : ", responseData)
  }, [])
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. {response?.question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
            {response?.question?.is_mandatory && (
              <span style={{ marginLeft: "20px", color: "#AC1616", fontSize: "10px", fontWeight: "700" }}>
                *Mandatory
              </span>
            )}
          </div>
        </div>

        {response?.question?.attachments?.length > 0 &&
          response?.question?.attachments?.map((attachment, index) => (
            <div key={index}>
              {attachment.split(".").pop() !== "mp4" ? (
                <>
                  {attachment.split(".").pop() === "jpg" ||
                    attachment.split(".").pop() === "jpeg" ||
                    attachment.split(".").pop() === "JPEG" ||
                    attachment.split(".").pop() === "JPG" ||
                    attachment.split(".").pop() === "PNG" ||
                    attachment.split(".").pop() === "png" ? (
                    <img
                      style={{ cursor: "pointer" }}
                      className="mt-3 imageWidthAndHeight"
                      src={IP + attachment?.replace(/^\./, "")}
                      alt="Attachment"
                      onClick={() => {
                        if (!isError) {
                          handleClick(attachment);
                        }
                      }}
                    />
                  ) : (
                    <div
                      key={index}
                      onClick={(e) =>
                        setPedingSubDetail({
                          ...pedingSubDetail,
                          pdfView: true,
                          attachment: attachment,
                        })
                      }
                      className="mt-2"
                    >
                      <div className="d-flex pdfContainer gap-2 p-2 ">
                        <div className="d-flex align-items-center">
                          <img
                            className="extention_icon"
                            src={`${iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment?.match(/\.([^.]+)$/)[1]
                            )?.icon
                              }`}
                            alt=""
                          />
                        </div>
                        <div className="w-100">
                          <div className="pdfName">
                            {attachment?.replace(/^[^_]*_/, "")}
                          </div>
                          <div className="pdfFileSize">12 KB</div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="d-flex pdfContainer gap-2 p-2 "
                  onClick={() => {
                    if (!isError) {
                      handleClick(attachment);
                    }
                  }}>
                  <div className="d-flex align-items-center">
                    <img
                      className="extention_icon"
                      src={`${iconData?.find(
                        (i) =>
                          i.extension ===
                          attachment?.match(/\.([^.]+)$/)[1]
                      )?.icon
                        }`}
                      alt=""
                    />
                  </div>
                  <div className="w-100">
                    <div className="pdfName">
                      {attachment?.replace(/^[^_]*_/, "")}
                    </div>
                    <div className="pdfFileSize">12 KB</div>
                  </div>
                </div>
              )}
            </div>
          ))}

        {/* <div className=" optionContainer mt-4">
          <div className="d-flex justify-content-between totalContainerUserNotAnswer align-items-center  ">
            <div className=" d-flex align-items-center gap-3 ">
              <div>
                <input type="checkbox" />
              </div>
              <div className="QueOptions d-flex align-items-center">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between totalContainerUserAnswer align-items-center ">
            <div className="d-flex align-items-center gap-3 ">
              <div className="d-flex align-items-center">
                <input type="checkbox" checked />
              </div>
              <div
                className={` ${
                  checkboxes ? "QueOptionsChecked" : "QueOptions"
                }`}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </div>
            </div>
            {checkboxes && <div className="yourAnswer">Your answer</div>}
          </div>

          <div className="d-flex justify-content-between totalContainerUserNotAnswer  align-items-center ">
            <div className=" d-flex align-items-center gap-3 ">
              <div>
                <input type="checkbox" />
              </div>
              <div className="QueOptions d-flex align-items-center">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between totalContainerUserNotAnswer  align-items-center ">
            <div className=" d-flex align-items-center gap-3 ">
              <div>
                <input type="checkbox" />
              </div>
              <div className="QueOptions d-flex align-items-center">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </div>
            </div>
          </div>
        </div> */}
        <div className=" optionContainer mt-4">
          {response?.question?.options?.length > 0 &&
            response?.question?.options?.map((option, index) => {
              return (
                <>
                  <div
                    key={option.key}
                    className={
                      option?.key === response?.answer?.key
                        ? "d-flex justify-content-between align-items-center mt-2 totalContainerUserAnswer"
                        : "d-flex justify-content-between align-items-center mt-2 totalContainerUserNotAnswer"
                    }
                  >
                    <div className="d-flex gap-3 ">
                      <div>
                        {
                          option?.key + ".  "
                        }
                        {
                          type == "SA" ?
                            <input
                              type="checkbox"
                              className="hwCheckbox ml-2"
                              name={"qustion_" + response?.question?.id}
                              value={response?.answer?.key}
                              checked={option?.key === response?.answer?.key}
                              onChange={handleCheckboxChange}
                            />
                            :
                            <input
                              type="checkbox"
                              className="hwCheckbox"
                              readOnly
                              checked={option?.key === response?.answer?.key}
                            />
                        }

                      </div>
                      <div
                        className={` ${option?.key === response?.answer?.key
                          ? "QueOptionsChecked"
                          : "QueOptions"
                          }`}
                      >
                        {option?.value}
                      </div>
                    </div>
                    {option?.key === response?.answer?.key && (
                      <div className="yourAnswer">Your answer</div>
                    )}
                  </div>
                  <div className="ml-7">
                    {option.attachment &&
                      (() => {
                        const ext = option.attachment.split(".").pop().toLowerCase();
                        const isImage = ["jpg", "jpeg", "png"].includes(ext);
                        return isImage ? (
                          <ZoomableImage src={option.attachment} />
                        ) : null;
                      })()}
                  </div>
                </>
              )
            })}
        </div>
      </div>
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        setIsError(false)
                        handleClick()
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
